import React, { useState, useEffect } from "react";
import CustomTextField from "./CustomTextField";
import CustomDropdown from "./CustomDropdown";
import CustomButton from "./CustomButton";
import { toast } from "react-toastify";
import { useOrganizationApi } from "../api/organization";
import { decodeJwt } from "../util/decodeJwt";
import "../styles/layout.css";

export default function OrganizationCreateDialog({ onClose, onCreate }) {
  const { createVendorOrg } = useOrganizationApi();
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    address: "",
    phoneNumber: "",
    email: "",
    gst: "",
    status: "active",
    userId: "",
  });

  const [loading, setLoading] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [isUserDropdownDisabled, setIsUserDropdownDisabled] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  // Decode JWT
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = decodeJwt(token);
      setCurrentUser(decoded);
      setFormData((prev) => ({
        ...prev,
        userId: decoded?._id || "",
      }));
    }
  }, []);


  // Auto-select type if only one available
  useEffect(() => {
    const typesMap = {
      admin: ["manufacturer"],
      manufacturer: ["distributor"],
      distributor: ["dealer"],
      dealer: ["customer"],
    };

    const availableTypes = typesMap[currentUser?.role] || [];
    if (availableTypes.length === 1 && !formData.type) {
      setFormData(prev => ({ ...prev, type: availableTypes[0] }));
    }
  }, [currentUser]);

  // Auto-select user if only one option
  useEffect(() => {
    if (userOptions.length === 1 && !formData.userId) {
      setFormData(prev => ({ ...prev, userId: userOptions[0].value }));
    }
  }, [userOptions]);

  const handleSubmit = async () => {
    if (!formData.name || !formData.phoneNumber || !formData.email || !formData.userId) {
      toast.warn("⚠️ Please fill all required fields including selecting a user");
      return;
    }

    try {
      setLoading(true);
      const newOrg = await createVendorOrg(formData);
      toast.success("Organization created successfully!");
      if (onCreate) onCreate(newOrg.data); // Pass created org back to parent
    } catch (err) {
      toast.error(err.message || "❌ Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>Create Organization</h2>
        <div className="modal-columns">
          <div className="modal-left">
            <CustomTextField
              label="Organization Name"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
            <CustomTextField
              label="Address"
              value={formData.address}
              onChange={(e) => handleChange("address", e.target.value)}
              multiline
              rows={4}
            />
            <CustomTextField
              label="Email ID"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </div>
          <div className="modal-right">
            <CustomDropdown
              label="Organization Type"
              value={formData.type}
              onChange={(val) => handleChange("type", val)}
              options={[
                { value: "manufacturer", label: "Manufacturer" },
                { value: "distributor", label: "Distributor" },
                { value: "dealer", label: "Dealer" },
                { value: "customer", label: "Customer" },
              ].filter(t => (currentUser?.role === "admin" && t.value === "manufacturer") ||
                           (currentUser?.role === "manufacturer" && t.value === "distributor") ||
                           (currentUser?.role === "distributor" && t.value === "dealer") ||
                           (currentUser?.role === "dealer" && t.value === "customer"))}
              isMultiSelect={false}
            />
            <CustomDropdown
              label="Status"
              value={formData.status}
              onChange={(val) => handleChange("status", val)}
              options={[
                { value: "active", label: "Active" },
                { value: "inactive", label: "Inactive" },
              ]}
              isMultiSelect={false}
            />
            <CustomTextField
              label="Phone Number"
              numericOnly
              value={formData.phoneNumber}
              onChange={(e) => handleChange("phoneNumber", e.target.value)}
            />
            <CustomTextField
              label="GST Number"
              value={formData.gst}
              onChange={(e) => handleChange("gst", e.target.value)}
            />
            {/* <CustomDropdown
              label="Assign User"
              value={formData.userId}
              onChange={(val) => handleChange("userId", val)}
              options={userOptions}
              disabled={isUserDropdownDisabled}
              isMultiSelect={false}
            /> */}
          </div>
        </div>
        <div className="modal-buttons">
          <CustomButton label="Cancel" className="org-cancel" onClick={onClose} />
          <CustomButton
           className="org-create"
            label={loading ? "Creating..." : "Create"}
            onClick={handleSubmit}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
}
